var _effectorFileName = "/builds/gmini/front-ui-kit/src/FormulaInput/SuggestionList.tsx";
import React, { useEffect, useRef } from 'react';
import { HighlightText } from '../HighlightText';
import { Popover, Suggestion } from './SuggestionList.styled';
import { jsx as _jsx } from "react/jsx-runtime";
export const SuggestionList = ({
  suggestions,
  selectedSuggestions,
  focusedSuggestionIdx,
  onClickSuggestion,
  onMouseEnterSuggestion,
  containerRef,
  search
}) => {
  const popoverRef = useRef(null);
  useEffect(() => {
    var _containerRef$current, _containerRef$current2;

    // Динамический расчета высоты и положения списка подсказок свойств у формул
    // TODO Создать переиспользуемый компонент Popover и вынести всю логику ниже в него
    const paddingPopoverToBottomViewPortPx = 20;
    const paddingPopoverToTopViewPortPx = 150;
    const minHeightPopoverPx = 250;
    const heightSuggestionPx = 40;
    const popoverEl = popoverRef.current;
    const offsetFromBottomViewPort = window.innerHeight - Number((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getBoundingClientRect().bottom) - paddingPopoverToBottomViewPortPx;
    const offsetFromTopViewPort = Number(Number((_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.getBoundingClientRect().top) - paddingPopoverToTopViewPortPx);
    const isAllSuggestionsFitsToBottom = heightSuggestionPx * suggestions.length <= offsetFromBottomViewPort;
    const isAllSuggestionsFitsToTop = heightSuggestionPx * suggestions.length <= offsetFromTopViewPort;
    const offsetBottomIsSmall = offsetFromBottomViewPort < minHeightPopoverPx;

    if (offsetBottomIsSmall && containerRef.current) {
      popoverEl.style.bottom = `${containerRef.current.clientHeight}px`;
    }

    if (!isAllSuggestionsFitsToBottom) {
      popoverEl.style.height = `${offsetFromBottomViewPort}px`;
    } else {
      popoverEl.style.height = 'initial';
    }

    if (offsetBottomIsSmall && !isAllSuggestionsFitsToTop) {
      popoverEl.style.height = `${offsetFromTopViewPort}px`;
    }
  }, [containerRef, suggestions.length]);
  return /*#__PURE__*/_jsx(Popover, {
    ref: popoverRef,
    children: suggestions.map((item, i) => {
      let group = '';
      let key = item.name;
      let selectedSuggestion = false;

      if (item.type === 'mention') {
        group = item.groupName;
        key = item.id;
        selectedSuggestion = Boolean(selectedSuggestions === null || selectedSuggestions === void 0 ? void 0 : selectedSuggestions.some(({
          property
        }) => (property === null || property === void 0 ? void 0 : property.id) === item.id));
      }

      return /*#__PURE__*/_jsx(Suggestion, {
        hover: i === focusedSuggestionIdx,
        active: selectedSuggestion,
        onMouseEnter: () => onMouseEnterSuggestion(i),
        onClick: () => onClickSuggestion(i),
        children: /*#__PURE__*/_jsx(HighlightText, {
          text: `${group ? `${group}.` : ''}${item.name}`,
          pattern: search
        })
      }, key);
    })
  });
};
export default SuggestionList;